import { render, staticRenderFns } from "./ZhengCaiInfo.vue?vue&type=template&id=73ba7d25&scoped=true&"
import script from "./ZhengCaiInfo.vue?vue&type=script&lang=js&"
export * from "./ZhengCaiInfo.vue?vue&type=script&lang=js&"
import style0 from "./ZhengCaiInfo.vue?vue&type=style&index=0&id=73ba7d25&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ba7d25",
  null
  
)

export default component.exports